exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-1636ad52]{color:#fff;background-color:#2281f9;border-radius:.375rem;border-color:#2281f9;height:45px;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transition:all .2s;transition:all .2s;font-size:1rem;font-weight:500}.link[data-v-1636ad52]:hover{text-decoration:none}.popup_suspicious-activity button[data-v-1636ad52]{text-transform:none;font-size:1rem;color:#2281f9;border-color:#2281f9}", ""]);

// exports
